import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../store/authSlice';  // ⭐ 추가
import { authAPI } from '../../services/api';

const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = async (values) => {
        try {
            setLoading(true);
            const response = await authAPI.login({
                login_id: values.login_id,
                password: values.password,
            });

            const { token, user, password_must_change } = response.data;

            dispatch(loginSuccess({ token, user }));

            // ⭐ 비밀번호 변경 필요 시
            if (password_must_change) {
                message.warning('초기 비밀번호를 변경해주세요');
                navigate('/change-password', { state: { isFirstLogin: true } });
            } else {
                message.success('로그인 성공');
                navigate('/dashboard');
            }
        } catch (error) {
            message.error(error.response?.data?.message || '로그인 실패');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}>
            <Card
                style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
                title={
                    <div style={{ textAlign: 'center' }}>
                        <h2 style={{ margin: 0, color: '#667eea' }}>아신씨엔티-스마트워크</h2>
                    </div>
                }
            >
                <Form
                    name="login"
                    onFinish={handleLogin}
                    layout="vertical"
                >
                    <Form.Item
                        name="login_id"
                        rules={[{ required: true, message: '사번 또는 이메일을 입력하세요' }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="사번 또는 이메일"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '비밀번호를 입력하세요' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="비밀번호"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>자동 로그인</Checkbox>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            loading={loading}
                        >
                            로그인
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginPage;